/**
 * Waitlist API functions
 * Uses the OpenAPI generated WaitlistService
 */

import { WaitlistService } from '../services/waitlistService';

/**
 * Add entry to waitlist
 * @param {Object} data - Waitlist entry data
 * @param {string} data.email - Email address
 * @param {string} data.firstName - First name
 * @param {string} data.lastName - Last name
 * @param {string} data.userType - User type: 'BUYER' or 'SUPPLIER'
 * @param {string} [data.additionalInfo] - Additional information (optional)
 * @param {string} [data.companyName] - Company name (optional)
 * @returns {Promise<Object>} Response object with success status and data/error
 */
export async function addToWaitlist(data) {
    try {
        const response = await WaitlistService.postApiV2Waitlist({
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            userType: data.userType,
            additionalInfo: data.additionalInfo || null,
            companyName: data.companyName || null,
        });

        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Error adding to waitlist:', error);
        // Handle OpenAPI client errors
        const errorMessage = error.body?.message || error.message || 'Failed to add to waitlist';
        return {
            success: false,
            error: errorMessage,
        };
    }
}

